export const PAY_RUN_ALLOWED_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'FINANCE_OFFICER',
  'PAYROLL_OFFICER',
] as const;

export const XERO_PAY_RUN_PUSH_ALLOWED_ROLES = [
  'OWNER',
  'TENANT_ADMIN',
  'FINANCE_OFFICER',
  'SYSTEM_ADMIN',
] as const;

export function canManagePayRuns(role: string | null | undefined): boolean {
  return Boolean(role && (PAY_RUN_ALLOWED_ROLES as readonly string[]).includes(role.toUpperCase()));
}

export function canPushPayRunToXero(role: string | null | undefined): boolean {
  return Boolean(
    role && (XERO_PAY_RUN_PUSH_ALLOWED_ROLES as readonly string[]).includes(role.toUpperCase()),
  );
}

export const PAY_RUN_PAID_SOURCE_STATUSES = ['EXPORTED', 'RECONCILED'] as const;

export function canMarkPayRunPaid(
  status: string | null | undefined,
  options?: { validationOnly?: boolean },
): boolean {
  if (options?.validationOnly) return false;
  return Boolean(status && (PAY_RUN_PAID_SOURCE_STATUSES as readonly string[]).includes(status));
}
